<template>
   <Menu  ref="side_menu"  :active-name=20001   :open-names="[20000]"   width="auto">
		<Submenu :name="items.menuId" v-for="(items,index)  in managerMenus"  :key="index"  >
			<template slot="title">
				<Icon :type="items.menuIcon" />
				{{items.menuName}}
			</template>
			<MenuItem :name="smaleItems.menuId" :to="smaleItems.menuLocation"  :key="smaleIndex" v-for="(smaleItems,smaleIndex) in items.children">
			   {{smaleItems.menuName}}
			</MenuItem>
		</Submenu>
	</Menu> 
 
</template>

<script>
	import {
		getCommonMenu
	} from '@/network/index.js';
	export default { 
		name: "MyMenu",
		props: {

		},
		data() {
			return {
				managerMenus: [],
				theme: 'light',
				openMenu: [],
				ifCommon: false,
			}
		},
		created() {
			let roles = this.$store.state.userInfo.roles[0];
			if (roles == "ROLE_COMMON") {
				this.ifCommon = true;
			}

			let paramter = {
				iconType: '1',
				myPt:null
			};
			
			//如果是普通用户隐藏几个菜单
			if(this.ifCommon){
				paramter.myPt='1'
			}
			console.log('paramter.iconType:'+paramter.iconType);
			console.log('paramter.myPt:'+paramter.myPt);
			
			this.managerMenus = [];
			this.openMenu = [];
			getCommonMenu(paramter).then(res => {
					for (var i = 0; i < res.data.obj.length; i++) {
						//console.log(res.data.obj[i]);
						this.managerMenus.push({
							menuId: res.data.obj[i].menuId ,
							menuName: res.data.obj[i].menuName,
							menuIcon: res.data.obj[i].menuIcon,
							parentMenuId: res.data.obj[i].parentMenuId,
							menuLocation: res.data.obj[i].menuLocation,
							menuLevelCode:res.data.obj[i].menuLevelCode,
							children:res.data.obj[i].children,
						}); 
					}
					this.$nextTick(()=>{
					                    this.$refs.side_menu.updateOpened();
					                    this.$refs.side_menu.updateActiveName()
					                })
					//console.log('0:'+JSON.stringify(this.managerMenus));
					//console.log('1:'+this.openMenu);
				})
				.catch(error => {});
				
				
			this.$router.push('/myProfile/userInfo')	
			 
		},
		computed: {

		},
		methods: {
			itemClick() {
				this.$router.replace(this.path)
			}
		}
	}
</script>

<style lang="scss">

</style>
